import '../bootstrap.js';
import '../bugsnag.js';
import '#css/app.css';

import App from '#login/LoginApp.svelte';
import { mount } from 'svelte';


mount(App, {
    target: document.getElementById('loginApp'),
    props: {
        // eslint-disable-next-line no-undef
        errors: loginErrors,
        // eslint-disable-next-line no-undef
        helpScoutRedirectInfo: helpScoutRedirectInfo,
    },
});
